<template>
    <div class="teachingUploadDialog">
        <el-dialog title="批量导入" width="50%"  :visible.sync="dialogVisible" :close-on-click-modal="false">
            <div v-show="!process"> 
                
                <el-row>
                    
                    <!-- <el-col :span="16"> -->
                        <el-upload class="upload-demo" drag action
                                :multiple="false"
                                :show-file-list="true"
                                :file-list="fileList"
                                accept=".xlsx"
                                :http-request="importByJava">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传excel文件，自动识别数据格式</div>
                        </el-upload>


                </el-row>
                <el-row>
                    <el-link :href="downloadUrl+'/teaching/import_batch_demo.xlsx'" download="批量创建教学班示例.xlsx" type="primary">批量导入示例下载</el-link>
                </el-row>

                <el-row >
                    <div align='left' v-if="erroeMessage != null">

                        <el-alert
                            title="导入失败"
                            type="error"
                            :closable="false"
                            :description="erroeMessage"
                            show-icon
                            class="alert-multiline"
                            >
                        </el-alert>
                    </div>
                
                </el-row>
          
            </div>
            <div v-show="process">
                <h1 style="font-size: 25px;" v-show="importStatus == 'processing'">
                    当前已处理到 <span style="font-size: 25px; color: #0e70fb;"> {{ processNum }} </span>条
                </h1>
                <h1  v-show="importStatus == 'over'"  >
                    成功导入 <span style="font-size: 25px; color: #0e70fb;"> {{ successCount }} </span> 条 
                    异常数据 <span style="font-size: 25px; color: red;"> {{ errorCount }} </span>条
                </h1>
                <h1 style="font-size: 25px; color: red;" v-show="importStatus == 'error'" > 导入异常</h1>
                <h1 style="font-size: 20px;" v-show="importStatus == null"> 请稍等... </h1>
                <el-button type="primary" @click="getProcessByTask" style="margin-top: 10px;" v-show="importStatus != 'error'">
                    <span v-if="importStatus == 'processing'">刷新进度</span>
                    <span v-else>重新获取</span>
                </el-button>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import * as simpleApi from "request/simple";
    import XEUtils from 'xe-utils'
    import * as mUtils from '@/utils/mUtils'
    import XLSX from "xlsx";

    export default {
        name: 'teachingUploadDialog',
        data(){
            return {
                formLabelWidth: '120px',
                dialogVisible:false, uploading: false, downloadUrl: null,
                tableData: [], isCanUpload: false,
                teachingClassId: null,
                searchForm:{ pageNo: 1, pageSize: 200, totalCount: 0, searchText: null, schoolId: null, professionId: null, year: null,},
                studentCol: [{prop: 'name', label: '姓名', colName: '姓名', check: true, }, {prop: 'myNo', label: '学号', colName: '学号', check: true, },
                    {prop: 'hardClassName', label: '行政班名称', colName: '行政班名称',  }, {prop: 'schoolName', label: '单位', colName: '单位' },
                    {prop: 'year', label: '入学年', colName: ' 入学年', }, {prop: 'professionName', label: '专业', colName: '专业',  },
                    {prop: 'phoneNo', label: '手机号', colName: '手机号（选填）', },
                    {prop: 'status', label: '状态', colName: null, }],
                erroeMessage: null,
                fileList:[],
                taskId: null,
                // 导入进度窗口
                importStatus: null,
                process: false,
                processNum: 0,
                // 导入进度定时器
                timer: null, 
                successCount: 0, 
                errorCount: 0
            }
        },
        components:{
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
        },
      	mounted() {
            this.downloadUrl = window.g.DEMO_URL;
	    },
        props: {
            teachingClass: {
                type: Object
            }
        },
        watch: {
            teachingClass: {
                deep: true, immediate:true,
                handler(n, o){
                    if(n){
                        this.teachingClassId = n.id
                    }
                }
            },
        },
        methods: {
            showDialog(){
                this.dialogVisible = true;
            },
            hideDialog(){
                this.dialogVisible = false;
            },
            cancel(){
                this.$message.info("已刷新导入任务")
                // 取消的话 清空定时器 清空当前任务id
                this.stopPolling()
                this.taskId = null
                this.process = false
                this.importStatus = null
                this.dialogVisible = false;
                this.$emit('ok');
            },
            formatterStatus(row, column, cellValue, index) {
                if(column.property == 'status'){
                    if(cellValue == '00') return '通过';
                    if(cellValue == '01') return '不存在';
                    if(cellValue == '02') return '检查中';
                    if(cellValue == '10') return '上传成功';
                    if(cellValue == '11') return '上传失败';
                    if(cellValue == '98') return '必填值为空';
                    if(cellValue == '99') return '无法上传';

                }
                return cellValue;

            },
            uploadRowStyle({row, rowIndex}){
                if(row.status == '99' || row.status == '98' || row.status == '03' || row.status == '11'){
                    console.log(rowIndex, row);
                    return {color: 'red' };
                }
                if(row.status == '00'){
                    console.log(rowIndex, row);
                    return {color: 'grey' };
                }
            },
            httpRequest(e) {
                let file = e.file; // 文件信息
                if (!file) {
                    // 没有文件
                    return false;
                } else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                    // 格式根据自己需求定义
                    this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
                    return false;
                }

                const fileReader = new FileReader();
                let this_ = this;

                // fileReader.onload = ev => {
                //     try {
                //         const data = ev.target.result;
                //         const workbook = XLSX.read(data, {
                //             type: "binary" // 以字符编码的方式解析
                //         });
                //         console.log(workbook)
                //         const exlname = workbook.SheetNames[0]; // 取第一张表
                //         let exlData = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容
                //         console.log(exlData);
                //         if(!exlData || exlData.length == 0){
                //             this.$message.error("数据格式错误");
                //             return false;
                //         }

                //         if(this.studentFound(exlData)) {
                //             this.isCanUpload = true;
                //             this.moduleName = 'student';
                //             this.postChecking('student');
                //             return ;
                //         }

                //         this.$message.error("数据格式错误");
                //         return false;

                //     } catch (e) {
                //         console.log(e);
                //         console.log("出错了：：", e);
                //         return false;
                //     }
                // };
                // fileReader.readAsBinaryString(file);
            },
            studentFound(exlData){
                let first = exlData[0];
                if('姓名' in first && '学号' in first){
                    this.readAndSetData(exlData, this.studentCol);
                    return true;
                }
                return false;
            },
            readAndSetData(exlData, columns){
                let tableData = [];

                for(let i=0; i<exlData.length;i++){
                    let d = exlData[i];
                    let p = { status: '02' }
                    for(let j=0; j<columns.length; j++){
                        let col = columns[j];
                        if(col.colName != null && col.colName in d) {
                            let v = String(d[col.colName]);
                            if("check" in col && col.check && (v==null || v=='')) p.status = '98';
                            p[col.prop] = v
                        }
                    }
                    tableData.push(p);
                }
                console.log('readAndSetData', tableData)
                this.tableData = tableData;
            },
            postChecking(moduleName){
                this.isCanUpload = false;
                let p = { licenceId: this.userInfo.licenceId, moduleName: moduleName, data: this.tableData };
                let param = { controllerName: 'teacherStudent/upload', methodName: '/check', param: p};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    console.log('postChecking', code);
                    if (code == 0) {
                        this.tableData =data;
                        for(let i=0; i<data.length; i++){
                            let d = data[i];
                            if(d.status == '99'){
                                this.isCanUpload = false;
                                return;
                            }
                        }
                        this.isCanUpload = true;
                    }

                }).catch((error) => {
                    this.isCanUpload = false;
                });
            },
            submitUpload(){

                let tableData = [];
                let isUpload = false;
                for(let i=0; i<this.tableData.length;i++){
                    let d = this.tableData[i];
                    if(d.status == '99' || d.status == '98' || d.status == '11'){
                        continue;
                    }
                    tableData.push(d);
                    isUpload = true;
                }
                if(!isUpload){
                    this.$message.error("无效数据，请重新整改再上传");
                    return false;
                }
                this.uploading = true;
                let p = { licenceId: this.userInfo.licenceId, teachingClassId: this.teachingClassId, data: tableData };
                let param = { controllerName: 'teacherStudent/upload', methodName: '/save', param: p};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    console.log('upload', code, data);
                    if (code == 0) {
                        this.tableData =data;
                        this.uploading = false;
                        this.isCanUpload = false;
                    }

                }).catch((error) => {
                    this.uploading = false;
                });
            },
            deleteStudent(index){
                this.tableData.splice(index,1);
            },
            // 导入测试
            async handleFileChange(e){
                let file = e.file; // 文件信息
                const formData = new FormData()
                formData.append('excel', e.raw)
                formData.append('userId', this.userInfo.id)
                // fjjj测试用户 假装是经济学校的用户插入
                // formData.append('userId', "6e99b519ac7740c6b19dae6b654d0688")
                try {
                    // 注意：不要设置 Content-Type，浏览器会自动设置 multipart/form-data
                    const response = await fetch(window.g.BAIDU_DOWN_URL + `/api/importBatch` , {method: 'POST', body: formData});
                    const result = await response.json();
                    if (!response.ok) {    
                        this.erroeMessage = result.message
                    }
                    if(!result.success){
                        // 导入失败 提示错误信息
                        this.erroeMessage = result.message
                    }else{
                        // 导入成功
                        this.erroeMessage = null
                        this.dialogVisible = false
                        this.$message.success("批量导入成功！")
                    }
                    
                    
                    
                }catch (error) {
                    // const result = await response.json();
                  
                }
            },
            // java 导入测试
            importClassTest(e){
                debugger
                console.log("Java 测试导入==========");
                const formData = new FormData();
                formData.append('file', e.raw);
                // formData.append('userId', this.userInfo.id);
                formData.append('userInfo', JSON.stringify(this.userInfo)); 

                return axios.post('/sclTeachingClass/import', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(response => {
                    const { code, data } = response.data;
                    debugger
                    // 处理结果
                }).catch(error => {
                    debugger
                    console.error('上传失败', error);
                });
            },
            
            // 改成 :http-request 只需要改参数来源
            importByJava(option) {  
                debugger
                // 清空当前的任务id
                this.taskId = null
                this.process = false
                const formData = new FormData();
                formData.append('file', option.file);  // e.raw → option.file
                formData.append('userInfo', JSON.stringify(this.userInfo));
                
                return axios.post('/sclTeachingClass/import', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(response => {
                    let taskId = response.data
                    if(taskId != null) {
                        this.taskId = taskId
                        // 触发进度窗口
                        this.process = true
                        this.startPolling()
                    }
                   
                    // debugger
                    // console.log(response.data);
                    // option.onSuccess(response.data);  // 告诉组件完成了
                    // let data = response.data
                    // let errorCount = data.errorCount
                    // if(errorCount > 0)  {
                    //     this.exportError(data.errorList)
                    //     this.$message.error("存在导入失败数据，请等待错误列表下载")
                    // } 
                    // // 关闭窗口
                    // this.dialogVisible = false

                }).catch(error => {
                    option.onError(error);  // 告诉组件失败了
                    this.dialogVisible = false
                });
            },
            // 根据用户信息 转excel表格
            exportError(list){
                // debugger
                // 1. 定义列名（中文表头）
                const sheetData = list.map(item => ({
                    '*学生学号': item.studentNo,
                    '*教学班名称': item.teachingClassName,
                    '*教师工号': item.teacherNo,
                    '*课程编号': item.classCode,
                    '*学年学期': item.semester,
                    '*错误原因': item.errorMake
                }));
                
                // 2. 创建工作表
                const ws = XLSX.utils.json_to_sheet(sheetData);
                
                // 4. 创建工作簿
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, '错误数据');
                
                // 5. 下载
                XLSX.writeFile(wb, `错误数据_${new Date().getTime()}.xlsx`);

            },
            getProcessByTask(){
                let param = { controllerName: 'sclTeachingClass', methodName: '/getTaskId', param: { taskId: this.taskId }};
                    simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        debugger
                        let status = data.status
                        this.importStatus = status
                        if(status == "processing"){
                            // 导入中 更新已处理行数
                            let num = data.currentRow == null ? 0 : data.currentRow
                            this.processNum = num
                        }else if(status == "over"){
                            let num = data.currentRow == null ? 0 : data.currentRow
                            this.processNum = num
                            // 导入结束，到处异常数据并提示错误条数和导入数
                            let errorList = JSON.parse(data.errorList)
                            let errorCount = errorList.length
                            this.errorCount = errorCount
                            this.successCount = num
                            if(errorCount > 0)  {
                                let count = num - errorCount
                                this.successCount = count
                                this.exportError(errorList)
                                this.$message.error("存在导入失败数据，请等待错误列表下载")
                            }
                    

                            
                            // 停止轮询
                            this.stopPolling()
                        }else {
                            // 导入异常 提示异常窗口并
                            this.$message.error("导入异常，请检查导入文件！")
                            // 停止轮询
                            this.stopPolling()
                        }
                    });
            },
            // 开始轮询
            startPolling() {
                // 每2秒请求一次
                this.timer = setInterval(() => {
                    this.getProcessByTask()
                }, 2000)
            },
            
            // 停止轮询
            stopPolling() {
                if (this.timer) {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }



        },
    }
</script>

<style lang="scss" scoped>
    .alert-multiline ::v-deep .el-alert__description {
        white-space: pre-line;
        font-size: 16px;  /* 调大字体 */
        line-height: 1.6; /* 增加行高 */
    }
</style>

